import React, { createContext, FC, useState } from 'react';

type ButtonToggleContextProps = {
  selected?: any[];
  setSelected?: (value: any) => void;
};
export const ButtonToggleContext = createContext<ButtonToggleContextProps>({});

const ButtonToggleProvider: FC<{ selected?: any[] }> = ({
  selected: selectedInitial,
  ...props
}) => {
  const [selected, setSelected] = useState(selectedInitial);
  return (
    <ButtonToggleContext.Provider
      value={{ selected, setSelected }}
      {...props}
    />
  );
};

export default ButtonToggleProvider;
